import React from 'react';
import { useTranslation } from 'react-i18next';
import './style.css';

const Months = (props) => {
    const { t } = useTranslation();
    let listMonth = props.months;
    let activeClass = props.classActive;
    let year = props.year;
    return (
        listMonth ?
            (<div className="month-preview">
                <h5 className="h4-title"> {t('months.title')}</h5>
                <ul className="month-box">
                    {listMonth.map((month, i) => {
                        const activeLink = activeClass === i ? 'activeNavLink month-link' : 'month-link';
                        return <li key={i} onClick={() => { props.getFolders(year,month, i) }}>
                            <span className={activeLink}> {month}</span>
                        </li>
                    })}
                </ul>
            </div>
            ) : null)
}

export default Months;


// WEBPACK FOOTER //
// ./src/components/foldersComponent/months.js